import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import orderBy from 'lodash/orderBy'
import { IoIosCloseCircle } from 'react-icons/io'

import { Form, FormGroup } from 'reactstrap'
import { AiOutlineSave } from 'react-icons/ai'
import { FaRegEdit } from 'react-icons/fa'
import { CustomDatePicker } from '../datepicker'
import { Input, SearchSelect } from '../input'
import { Button } from '../buttons'

import { FONTS } from '../../constants'

export const EditPane = ({
  isEdit,
  setIsEdit,
  openDetail,
  users = [],
  lobList,
  handleInput,
  selectedItem,
  handleClickSave,
  handleClickDelete,
  handleClickClose,
  handleClickCancel,
}) => {
  const lob = selectedItem ? lobList.find(l => l.value === selectedItem.lob_id) : ''
  const modified_by = selectedItem && users.find(u => u._id === selectedItem.updated_by)

  return (
    <Root openDetail={ openDetail }>
      <ModalHeader>
        <Header>Sale Product Detail</Header>
        <IoIosCloseCircle
          style={ { color: '#C4C4C4' } }
          onClick={ handleClickClose }
        />
      </ModalHeader>
      <FormWrapper>
        <Form>
          <FormGroup>
            <Label>Code</Label>
            <Input
              name='product_code'
              placeholder='Enter Code'
              disabled={ !isEdit }
              value={ selectedItem.product_code ? selectedItem.product_code : '' }
              onChange={ e => handleInput(e.target.value, 'product_code') }
            />
          </FormGroup>
          <FormGroup>
            <Label>Name</Label>
            <Input
              name='name'
              placeholder='Enter Name'
              disabled={ !isEdit }
              value={ selectedItem.name ? selectedItem.name : '' }
              onChange={ e => handleInput(e.target.value, 'name') }
            />
          </FormGroup>
          <FormGroup>
            <Label>LOB</Label>
            <SearchSelect
              name='lob_id'
              placeholder='Select LOB'
              value={ lob }
              isDisabled={ !isEdit }
              onChange={ e => handleInput(e, 'lob_id') }
              options={ orderBy(lobList, 'label', 'asc') }
            />
          </FormGroup>
          <FormGroup>
            <Label>Start date</Label>
            <CustomDatePicker
              showYearDropdown
              showMonthDropdown
              autoComplete='off'
              name='start_date'
              dateFormat='DD/MM/YYYY'
              disabled={ !isEdit }
              selected={ selectedItem.start_date ? moment(selectedItem.start_date) : null }
              onChange={ e => handleInput(e, 'start_date') }
            />
          </FormGroup>
          <FormGroup>
            <Label>End date</Label>
            <CustomDatePicker
              showYearDropdown
              showMonthDropdown
              autoComplete='off'
              name='end_date'
              dateFormat='DD/MM/YYYY'
              disabled={ !isEdit }
              selected={ selectedItem.end_date ? moment(selectedItem.end_date) : null }
              onChange={ e => handleInput(e, 'end_date') }
            />
          </FormGroup>
          <FormGroup>
            <ModifiedWrapper>
              <Label>Modified Date</Label>
              <ModifiedText>{selectedItem ? moment(selectedItem.updated).format('DD/MM/YYYY') : '-'}</ModifiedText>
            </ModifiedWrapper>
          </FormGroup>
          <FormGroup>
            <ModifiedWrapper>
              <Label>Modified By</Label>
              <ModifiedText>{modified_by ? `${modified_by.first_name} ${modified_by.last_name}` : '-'}</ModifiedText>
            </ModifiedWrapper>
          </FormGroup>
        </Form>
      </FormWrapper>
      <Footer>
        { openDetail && isEdit &&
        <Wrapper>
          <Button
            outline
            theme='#D44B49'
            width='70px'
            height='26px'
            onClick={ () => handleClickDelete(selectedItem._id) }
          >
            Delete
          </Button>
          <ButtonGroup>
            <Button
              theme='#28a745'
              icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
              width='70px'
              height='26px'
              onClick={ () => handleClickSave(selectedItem._id) }
            >
              Save
            </Button>
            <Button
              theme='#6c757d'
              width='70px'
              height='26px'
              onClick={ () => handleClickCancel(selectedItem._id) }
            >
              Cancel
            </Button>
          </ButtonGroup>
        </Wrapper>
        }
        { openDetail && !isEdit &&
          <Button
            theme='#28a745'
            icon={ <FaRegEdit style={ { fontSize: 16 } } /> }
            width='70px'
            height='26px'
            onClick={ () => setIsEdit(true) }
          >
            Edit
          </Button>
        }
      </Footer>
    </Root>
  )
}


const Root = styled.div`
    display: flex;
    flex-direction: column;
    flex: ${p => (p.openDetail ? 1 : 0)};
    width: ${p => (p.openDetail ? 'auto' : 0)};
    margin-left: ${p => (p.openDetail ? '12px' : 0)};
    transition: all 0.3s;
`

const Header = styled.span`
    font-family: ${FONTS.GOTHAM_BOLD};
    font-size: ${FONTS.SMALL_SIZE};
    color: #1A1A17;
`

const Footer = styled.div`
    height: 42px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #F9F9F9;
    padding: 0 24px;
`

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
`

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`

const FormWrapper = styled.div`
    padding: 16px 24px;
    background: #FFFFFF;
`

const ModifiedWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const ModifiedText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
`

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;

    div:nth-child(1) {
      margin-right: 12px;
    }
`

const ModalHeader = styled.div`
  width: 100%;
  height: 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  background: #F9F9F9;

  svg {
      font-size: 24px;
      color: #616161;
      cursor: pointer;
  }
`



// WEBPACK FOOTER //
// ./src/components/sale-product/edit-pane.js